import React from "react";
import { AppLayout } from "../../Layouts";
import PageLayout from "../../Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import SettingsContentLayout from "../../Layouts/SettingsContentLayout";
import ForgetPasswordContant from "../../Components/Features/Settings/ForgetPasswordContant";

function ChangePasswordPage() {
  const { t } = useTranslation();
  return (
    <AppLayout>
      <PageLayout title={t("change-password")}>
        <div className="h-fit md:h-screen w-full bg-white rounded-xl shadow-accent-foreground shadow-2xl ">
          <SettingsContentLayout>
            <ForgetPasswordContant />
          </SettingsContentLayout>
        </div>
      </PageLayout>
    </AppLayout>
  );
}

export default ChangePasswordPage;
